import GetWindowSize from '../components/GetWindowSize/GetWindowSize'
import { MOBILE_SCREEN_SIZE } from '../utils/constants/mobileScreen'

// A touch screen as the primary input. Without it a short or zoomed desktop window would count as
// a phone, and the calendar would turn read-only (and drop an open edit drawer) under its user.
const hasCoarsePointer = () =>
  typeof window !== 'undefined' && !!window.matchMedia?.('(pointer: coarse)').matches

// Either side under the threshold counts, so a phone held sideways is still a phone.
const useIsMobileScreen = () => {
  const { windowHeight, windowWidth } = GetWindowSize()
  const isSmall = windowWidth < MOBILE_SCREEN_SIZE || windowHeight < MOBILE_SCREEN_SIZE
  return isSmall && hasCoarsePointer()
}

export default useIsMobileScreen
